import { render, staticRenderFns } from "./linkDistribute.vue?vue&type=template&id=3c3f73c2&scoped=true"
import script from "./linkDistribute.vue?vue&type=script&lang=js"
export * from "./linkDistribute.vue?vue&type=script&lang=js"
import style0 from "./linkDistribute.vue?vue&type=style&index=0&id=3c3f73c2&prod&scoped=true&lang=scss"
import style1 from "./linkDistribute.vue?vue&type=style&index=1&id=3c3f73c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f73c2",
  null
  
)

export default component.exports